import { initialRequestStatusState, RequestStatusState } from '@portal/shared/store/request-status';
import { MenuState } from '../side-menu.types';

export interface SideMenuStateState {
  menuState: MenuState | null;
  loadRequest: RequestStatusState;
  saveRequest: RequestStatusState;
}

export const initialSideMenuStateState: SideMenuStateState = {
  menuState: null,
  loadRequest: initialRequestStatusState,
  saveRequest: initialRequestStatusState
};
